import { add, subtract, multiply, divide, merge, curry, isNil } from 'ramda'
import { fromJS } from 'immutable';

import {
  roundDownToNearest,
  roundToNearest,
  roundUpToNearest,
} from '../../../utils/rounding-helpers';

const roundNumber = ({ roundType, cents }, num) => {
  const newNum = Number(num);
  if (roundType === 'alwaysUp') return roundUpToNearest(newNum, cents);
  if (roundType === 'alwaysDown') return roundDownToNearest(newNum, cents);
  return roundToNearest(newNum, cents);
};

const calNettByDiff = curry((nettDiff, { retailNettMeasure, notApplyToExtraChild, roundingSetting }, rates) => rates.map(rate => {
  const initialNettRate = isNil(rate.get('initialNettRate')) ? // Check isNil because rate may be 0
    (isNil(rate.get('nettRate')) ? 0 : rate.get('nettRate')) : // if no nettRate then 0 else nettRate
    rate.get('initialNettRate');
  const nettRate = retailNettMeasure === 'percentage' ? multiply(initialNettRate, divide(add(Number(nettDiff), 100), 100)) :
    add(initialNettRate, Number(nettDiff));
  if (notApplyToExtraChild && (rate.get('description') === 'Extra Child' || rate.get('description') === 'Extra Adult')) return rate.set('nettRate', initialNettRate);
  return rate.get('notApplicable') ? rate : rate.merge(fromJS({
    initialNettRate,
    nettRate: nettDiff ? roundNumber(roundingSetting, nettRate).toFixed(2) : initialNettRate,
  }));
}));

export const updateRateSetsOrExtrasOrOffers = curry(({ nettDiff }, settings, rateSetsOrExtrasOrOffers) => {
  if (!rateSetsOrExtrasOrOffers) return rateSetsOrExtrasOrOffers;
  return rateSetsOrExtrasOrOffers.map(rateSet => {
    if (!rateSet) return rateSet;
    return rateSet.update('rates', calNettByDiff(nettDiff, settings));
  });
});



// WEBPACK FOOTER //
// ./src/app/stores/contracting/mass-rate-change/update-nett-rates.js